<div>
  @if (busy) {
    <div class="overlay">
      <div class="center">
        <mat-spinner>
        </mat-spinner>
      </div>
    </div>
  }
  <mat-card-content>
    <div class="flex-col justify-center items-center w-100" [formGroup]="placeholderForm">
      <div class="mb-2 items-center">The information entered below will populate the document which will be displayed for your review in the next step @if(canPreviewBlankDocument){, or preview the blank document<a mat-button (click)="onPreviewBlankClick()" class="primary-color">HERE</a>} @else{.} </div>
      <div formArrayName="placeholders" class="w-100 flex-col justify-start items-stretch">
        @for (placeholder of placeholdersArray.controls; track placeholder; let i = $index; let isLast = $last) {
          <div class="w-100 flex-col justify-start items-stretch pb-2 mt-2">
            <div [formGroupName]="i" class="w-100 flex-row flex-wrap justify-start items-center datewrapper">
              @if (getPlaceholderInputType(placeholder.value.name)=='bool') {
                <mat-slide-toggle [checked]="placeholder.value.value === 'true' ? true : false" class="mb-3" labelPosition="before" color="primary">{{getPlaceholderLabel(placeholder.value.name)}}</mat-slide-toggle>
              }
              @else{
                <mat-form-field  appearance="outline" subscriptSizing="dynamic" class="w-100">
                  <mat-label>{{getPlaceholderLabel(placeholder.value.name)}}</mat-label>
                  @if (getPlaceholderInputType(placeholder.value.name)=='slt') {
                    <input matInput formControlName="value" autocomplete="off" type="text" required>
                  }
                  @else if (getPlaceholderInputType(placeholder.value.name)=='mlt') {
                    <textarea  matInput formControlName="value" autocomplete="off" required></textarea>
                  }
                  @else if (getPlaceholderInputType(placeholder.value.name)=='opt') {
                    <mat-select placeholder="Select Option" formControlName="value" required>
                      @for (option of getPlaceholderInputOptions(placeholder.value.name); track option) {
                        <mat-option [value]="option" class="py-2">
                          {{option}}
                        </mat-option>
                      }
                    </mat-select>
                  }
                  @else if (getPlaceholderInputType(placeholder.value.name)=='num') {
                    <input matInput formControlName="value" autocomplete="off" type="number" onlyNumber required>
                  }
                  @else if (getPlaceholderInputType(placeholder.value.name)=='cur') {
                    <input matInput formControlName="value" autocomplete="off" type="text" required appBidAmount appTransformAmount [bidWithDecimals]="true" [transformWithDecimals]="true">
                  }
                  @else if  (getPlaceholderInputType(placeholder.value.name)=='pct') {
                    <input matInput formControlName="value" autocomplete="off" type="text" required appTransformPercent [max]="100">

                  }
                  @else if  (getPlaceholderInputType(placeholder.value.name)=='dte') {
                    <input matInput formControlName="value" autocomplete="off" type="datetime-local" [min]="minDate" required>
                  }
                  @else{
                    <input matInput formControlName="value" autocomplete="off" type="text" required>
                  }
                  @if (placeholder.errors?.max) { <mat-error>Cannot be more than 100</mat-error>}
                  @if (placeholder.errors?.required) { <mat-error>Input is required</mat-error>}
                  @if (getPlaceholderDescription(placeholder.value.name)) { <mat-hint  [matTooltip]="getPlaceholderDescription(placeholder.value.name)">{{getPlaceholderDescription(placeholder.value.name)}}</mat-hint> }
                </mat-form-field>
              }
            </div>
          </div>
        }
      </div>
    </div>
    <div class="flex-row justify-end items-center my-3">
      <button mat-flat-button color="primary" class="uppercase" type="submit" (click)="onPreviewDocument()" [disabled]="!canPreviewDocument" >
        {{confirmButtonText}}
      </button>
    </div>
  </mat-card-content>
</div>


